var urlString = process.env.REACT_APP_API_URL;
// var urlString = "http://192.168.1.173:8082/"

const GetApiCall = {
  getRequest(url) {
    const getToken = localStorage.getItem("authToken");

    return fetch(urlString + url, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Methods": "*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken}`,
      },
      // credentials: "include",
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("request failed", error);
        throw error;
      });
  },
};

export default GetApiCall;
